import { render, staticRenderFns } from "./CreateGlLevel1.vue?vue&type=template&id=0c22df6c&scoped=true&"
import script from "./CreateGlLevel1.vue?vue&type=script&lang=js&"
export * from "./CreateGlLevel1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c22df6c",
  null
  
)

export default component.exports